import * as _ from "lodash";

const parseAmount = (value: any): number => {
  const parsed = parseFloat(value);

  return _.isFinite(parsed) ? parsed : 0;
};

//The cart counts as gift-only when it has products and every root product is a gift
export function isGiftOnlyCart(cartProducts: any): boolean {
  return !!(
    cartProducts &&
    _.isArray(cartProducts) &&
    cartProducts.length &&
    _.every(cartProducts, (product) => !!(product && product.gift))
  );
}

//True when the store runs the gift-only free mode and the only charge left is the
//plastic wrapper tax, which the store absorbs. The customer sees "free" instead of
//prices and the order is sent as cash, but it is still created and printed with the
//tax exactly as before. Anything else that is payable - delivery cost, a tip, another
//cart custom option - keeps the order on the normal paid flow.
export function isGiftOnlyFreeOrder(
  storeInfo: any,
  cartProducts: any,
  cartPrices: any
): boolean {
  if (!storeInfo || !storeInfo.giftOnlyFreeMode || !cartPrices) {
    return false;
  }

  if (!isGiftOnlyCart(cartProducts)) {
    return false;
  }

  //Prices that have not loaded yet must not read as free
  const grandTotal = parseFloat(cartPrices.grand_total);

  if (!_.isFinite(grandTotal)) {
    return false;
  }

  const payableWithoutWrapperTax = parseFloat(
    (grandTotal - parseAmount(cartPrices.wrapperTaxTotal)).toFixed(2)
  );

  return payableWithoutWrapperTax === 0;
}
